import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../Datas/siteConfig";
import "../css/about.scss";

const values = [
  {
    number: "01",
    title: "Made for real weather",
    text: "Every layer starts with a simple question: will it help you stay outside for longer? Comfort, protection and freedom of movement guide every choice.",
  },
  {
    number: "02",
    title: "Built to be relied on",
    text: "We favour useful details, dependable materials and considered construction over short-lived trends, so each piece earns its place in your kit.",
  },
  {
    number: "03",
    title: "The outdoors is for everyone",
    text: "From a wet weekday walk to a first night under canvas, adventure can begin close to home. Our collections are designed for every kind of explorer.",
  },
];

function About() {
  const { brandName, shortName, description, tagline, services = [] } =
    siteConfig;

  return (
    <div className="about-page">
      <nav className="about-page__breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span aria-hidden="true">/</span>
        <span aria-current="page">About us</span>
      </nav>

      <header className="about-page__hero">
        <div className="about-page__hero-copy">
          <p className="about-page__eyebrow">Our story</p>
          <h1>Outside is where we belong.</h1>
          <p className="about-page__lead">{tagline}</p>
        </div>
        <div className="about-page__hero-art" aria-hidden="true">
          <span className="about-page__sun" />
          <span className="about-page__ridge about-page__ridge--back" />
          <span className="about-page__ridge about-page__ridge--front" />
          <strong>{shortName || brandName}</strong>
        </div>
      </header>

      <main className="about-page__main">
        <section className="about-page__intro" aria-labelledby="about-intro">
          <p className="about-page__section-label">Why we are here</p>
          <div>
            <h2 id="about-intro">Designed for the path ahead</h2>
            <p>{description}</p>
            <p>
              We make practical outdoor clothing, footwear and equipment for
              changing forecasts and everyday escapes. Each collection brings
              together protection, comfort and clean design without losing
              sight of what matters: helping people enjoy time outside.
            </p>
          </div>
        </section>

        <section className="about-page__values" aria-labelledby="our-values">
          <div className="about-page__section-heading">
            <p className="about-page__section-label">Our point of view</p>
            <h2 id="our-values">Adventure, made practical</h2>
          </div>
          <div className="about-page__value-grid">
            {values.map((value) => (
              <article className="about-page__value-card" key={value.number}>
                <span>{value.number}</span>
                <h3>{value.title}</h3>
                <p>{value.text}</p>
              </article>
            ))}
          </div>
        </section>

        {services.length > 0 && (
          <section
            className="about-page__services"
            aria-labelledby="about-services"
          >
            <div className="about-page__services-copy">
              <p className="about-page__section-label">Here when you need us</p>
              <h2 id="about-services">Support beyond the trailhead</h2>
              <p>
                Good equipment should be easy to choose and straightforward to
                own. Our service promises are designed to help before and after
                every order.
              </p>
              <Link className="about-page__text-link" to="/contact">
                Talk to our team
              </Link>
            </div>
            <div className="about-page__service-list">
              {services.map((service, index) => (
                <article key={service.title}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <div>
                    <h3>{service.title}</h3>
                    <p>{service.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}

        <section className="about-page__cta" aria-labelledby="about-cta">
          <div>
            <p className="about-page__section-label">Your next chapter</p>
            <h2 id="about-cta">Meet us outside.</h2>
          </div>
          <p>
            Find dependable layers and trail-ready equipment for the places
            that make you feel most alive.
          </p>
          <Link className="about-page__button" to="/shop">
            Explore the collection
          </Link>
        </section>
      </main>
    </div>
  );
}

export default About;
